import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  container: {
    padding: '30px 25px 50px 25px',
    width: 620,
    maxHeight: 550,
    overflow: 'auto',
    marginTop: 70,
    marginBottom: 70,
  },
}));
